import React, { forwardRef } from 'react';
import { View } from 'react-native';
import { HStack } from '@/components/gluestack/hstack';
import { VStack } from '@/components/gluestack/vstack';
import { Text } from '@/components/gluestack/text';
import { Switch } from '@/components/gluestack/switch';
import { Badge, BadgeText } from '@/components/gluestack/badge';
import { HugeIconsWrapper } from '@/components/ui/HugeIconsWrapper';
import type { HugeiconsProps } from '@hugeicons/react-native';

export interface ISettingsToggleProps {
  label: string;
  description?: string;
  value: boolean;
  onValueChange: (value: boolean) => void;
  className?: string;
  icon?: HugeiconsProps['icon'];
  iconClassName?: string;
  disabled?: boolean;
  badge?: string | React.ReactNode;
}

export const SettingsToggle = forwardRef<View, ISettingsToggleProps>(
  (
    {
      label,
      description,
      value,
      onValueChange,
      className,
      icon: LeftIcon,
      iconClassName,
      disabled,
      badge,
    },
    ref
  ) => {
    return (
      <View ref={ref} className={`px-2 py-2 web:py-3 -mx-2 rounded-xl ${className ?? ''}`}>
        <HStack className="items-center justify-between gap-2 native:mr-4 web:mr-2">
          <HStack className="flex-1 items-start gap-2 mr-3">
            {LeftIcon ? (
              <HugeIconsWrapper icon={LeftIcon} size={22} className={iconClassName ?? 'color-typography-500'} />
            ) : null}
            <VStack className="flex-1 gap-1">
              <HStack className="items-center gap-2">
                <Text className="font-semibold">{label}</Text>
                {badge ? (
                  typeof badge === 'string' ? (
                    <Badge variant="solid" size="sm" className="rounded-md bg-primary-500">
                      <BadgeText className="font-bold color-typography-0">{badge}</BadgeText>
                    </Badge>
                  ) : (
                    badge
                  )
                ) : null}
              </HStack>
              {description ? (
                <Text size="sm" className="text-typography-600">
                  {description}
                </Text>
              ) : null}
            </VStack>
          </HStack>
          <Switch
            value={value}
            onValueChange={onValueChange}
            disabled={disabled}
            accessibilityLabel={label}
          />
        </HStack>
      </View>
    );
  }
);

SettingsToggle.displayName = 'SettingsToggle';

